module.exports = __webpack_public_path__ + "static/Infographic4_5_Tainan-8c1f5e9615ff6eaff4894ec0760eafba.png";